/**
 * Tax rates logic.
 * @type {Window.jQuery|jQuery|HTMLElement|*}
 */
import drupalSettings from '../common/drupalSettings';

const $ = window.jQuery;
const TAX_RATES_INPUT_LENGTH = 2;

export default {
  attach: function (context, _) {
    const taxRates_once = once('tax-rates-once', 'section[data-block-plugin-id="tax_rates_block"]', context);

    $(taxRates_once).each(function () {
      let inputField = $(this).find('.tax-rate-autocomplete');
      let suggestionsUl = $(this).find('.tax-rate-suggestions');
      let buttonSearch = $(this).find('button.tax-rate-button-search');
      let buttonReset = $(this).find('button.tax-rate-button-reset');
      let results = $(this).find('.tax-rate-results');
      let resultsTable = $(this).find('table.tax-rate-results-table');
      let inputValuePrevious = '';

      // Get tax data from configuration.
      let taxData = Drupal.behaviors.taxRates.getData();

      if (taxData !== false) {
        inputField.on('focus', function (event) {
          suggestionsUl.show();
        });

        inputField.on('keyup', function (event) {
          if (event.key === 'ArrowDown') {
            // Focus first suggestion, if present.
            let firstSuggestion = suggestionsUl.find('> li:first-of-type');

            if (firstSuggestion.length) {
              suggestionsUl.show();
              firstSuggestion.focus();
            }
          }
          else if (event.key === 'ArrowUp') {
            // Focus last suggestion, if present.
            let lastSuggestion = suggestionsUl.find('> li:last-of-type');

            if (lastSuggestion.length) {
              suggestionsUl.show();
              lastSuggestion.focus();
            }
          }
          else if (event.key === 'Enter') {
            if (!buttonSearch.attr('disabled')) {
              // Trigger search button.
              buttonSearch.trigger('click');
            }
          }
          else if (event.key === 'Escape') {
            suggestionsUl.hide();
          }
          else {
            // Only if input value length has changed (key is not a function key).
            if ($(this).val().length !== inputValuePrevious.length) {
              // Reset data-id on the input.
              Drupal.behaviors.taxRates.setInput(inputField, buttonSearch, '-1');
              // Save input value to detect changes.
              inputValuePrevious = $(this).val();
            }
            // Remove previous suggestions.
            Drupal.behaviors.taxRates.clearAutosuggestions(suggestionsUl);
            // Get autosuggestions.
            Drupal.behaviors.taxRates.getAutosuggestions(taxData.places, $(this).val(), suggestionsUl);

            suggestionsUl.show();

            // If there is only one suggestion, then set that to the input, to make it searchable.
            if (suggestionsUl.children().length === 1) {
              Drupal.behaviors.taxRates.setInput(inputField, buttonSearch, $(suggestionsUl.children()[0]).attr('data-id'));
            }
          }
        });

        suggestionsUl.on('keyup', function(event) {
          if (event.key === 'ArrowDown') {
            if ($(document.activeElement).next().length) {
              $(document.activeElement).next().focus();
            }
            else {
              $(document.activeElement).parent().find('> li:first-of-type').focus();
            }
          }
          else if (event.key === 'ArrowUp') {
            if ($(document.activeElement).prev().length) {
              $(document.activeElement).prev().focus();
            }
            else {
              $(document.activeElement).parent().find('> li:last-of-type').focus();
            }
          }
          else if (event.key === 'Enter') {
            $(document.activeElement).trigger('click');
          }
        });

        suggestionsUl.on('click', function(event) {
          if (typeof $(event.target).attr('data-id') !== 'undefined') {
            // Set selected suggestion to input.
            Drupal.behaviors.taxRates.setInput(inputField, buttonSearch, $(event.target).attr('data-id'), $(event.target).text());
            // Save input value to detect changes.
            inputValuePrevious = inputField.val();
            inputField.focus();
            // Remove suggestions.
            Drupal.behaviors.taxRates.clearAutosuggestions(suggestionsUl);
            suggestionsUl.hide();
            // Trigger results on suggestion select.
            buttonSearch.trigger('click');
          }
        });

        buttonSearch.on('click', function(event) {
          suggestionsUl.hide();

          // Show results.
          Drupal.behaviors.taxRates.populateResults(taxData, inputField, resultsTable, results);
        });

        buttonReset.on('click', function(event) {
          suggestionsUl.hide();

          // Reset the data-id on the input.
          Drupal.behaviors.taxRates.setInput(inputField, buttonSearch, '-1', '');
          // Remove all suggestions.
          Drupal.behaviors.taxRates.clearAutosuggestions(suggestionsUl);
          // Remove the results.
          Drupal.behaviors.taxRates.clearResults(resultsTable, results);

          setTimeout(function() {
            inputField.focus();
          }, 100);
        });

        $(window).click(function(event) {
          // Hide suggestions when clicking outside of the inputField.
          if ($(event.target).attr('class') !== inputField.attr('class')) {
            suggestionsUl.hide();
          }
        });

        // Prevent window from scrolling on arrow keys while inputField or suggestionsUL is focused.
        window.addEventListener("keydown", function(event) {
          if (($(document.activeElement).attr('class') === inputField.attr('class')) || ($(document.activeElement).parent().attr('class') === suggestionsUl.attr('class'))) {
            if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(event.code) > -1) {
              event.preventDefault();
            }
          }
        }, false);
      }
    });
  },

  /**
   * Get tax rate data from settings.
   */
  getData: function() {
    let dSettings = new drupalSettings();
    let taxDataJson = dSettings.getDefinedDrupalSetting('tax_rates');

    if (taxDataJson.length) {
      return JSON.parse(taxDataJson);
    }

    return false;
  },

  /**
   * Clear autosuggestions.
   @param suggestionsUl
   */
  clearAutosuggestions: function(suggestionsUl) {
    suggestionsUl.find('li').remove();
  },

  /**
   * Get autosuggestions.
   @param taxDataPlaces
   @param inputValue
   @param suggestionsUl
   */
  getAutosuggestions: function(taxDataPlaces, inputValue, suggestionsUl) {
    if (inputValue.length >= TAX_RATES_INPUT_LENGTH) {
      for (const [key, value] of Object.entries(taxDataPlaces)) {
        if (value.toLowerCase().startsWith(inputValue.toLowerCase())) {
          suggestionsUl.append('<li tabindex="0" data-id="' + Drupal.behaviors.taxRates.escapeHtml(key) + '">' + Drupal.behaviors.taxRates.escapeHtml(value) + '</li>');
        }
      }
    }
  },

  /**
   * Set the data-id attribute and value of the input field and enable/disable the search button.
   @param inputField
   @param buttonSearch
   @param inputDataId
   @param inputValue
   */
  setInput: function(inputField, buttonSearch, inputDataId, inputValue) {
    inputField.attr('data-id', inputDataId);

    if ((typeof inputValue !== 'undefined')) {
      inputField.val(inputValue);
    }

    if (inputDataId === '-1') {
      buttonSearch.attr('disabled','disabled');
    }
    else {
      buttonSearch.removeAttr('disabled');
    }
  },

  /**
   * Clear and hide results.
   @param resultsTable
   @param results
   */
  clearResults: function(resultsTable, results) {
    resultsTable.find('tr').remove();
    results.hide();
  },

  /**
   * Populate results table and show results.
   @param taxData
   @param inputField
   @param resultsTable
   @param results
   */
  populateResults: function(taxData, inputField, resultsTable, results) {
    Drupal.behaviors.taxRates.clearResults(resultsTable, results);

    let dataId = inputField.attr('data-id');
    let resultsEntries = taxData.data[Object.keys(taxData.data)[dataId]];

    // Set the input value to the selected place, in case the value was not fully written.
    inputField.val(Drupal.behaviors.taxRates.escapeHtml(taxData.places[dataId]));

    resultsTable.append('<tr><th>' + Drupal.t("Name of the place") + ':</th><th>' + Drupal.behaviors.taxRates.escapeHtml(taxData.places[dataId]) + '</th></tr>');
    for (const [key, value] of Object.entries(resultsEntries)) {
      resultsTable.append('<tr><td>' + Drupal.behaviors.taxRates.escapeHtml(key) + ':</td><td>' + Drupal.behaviors.taxRates.escapeHtml(value) + '</td></tr>');
    }

    results.show();
  },

  /**
   * Escape HTML.
   @param unsafe
   */
  escapeHtml: function(unsafe) {
    return unsafe
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  },
}
